module.exports = __webpack_public_path__ + "assets/pizza_active-0d7da1.svg";